export default __webpack_public_path__ + "static/media/following-11.32362871.svg";